import {
  GET_SPECIFICATION_SUCCESS,
  GET_SPECIFICATION_ERROR,
  GET_SPECIFICATION_LIST_SUCCESS,
  GET_SPECIFICATION_LIST_ERROR,
} from "./actionTypes"

const statuslist = {
  idle: "idle",
  process: "process",
  success: "success",
  error: "error",
}

const INIT_STATE = {
  data: {},
  list: {},
  error: {},
  errorList: {},
  status: statuslist.idle,
}

const Specification = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_SPECIFICATION_SUCCESS:
      return {
        ...state,
        data: action.payload?.data,
        status: statuslist[action.payload.status],
      }

    case GET_SPECIFICATION_ERROR:
      return {
        ...state,
        data: {},
        error: action.payload?.data,
        status: statuslist.error,
      }
    case GET_SPECIFICATION_LIST_SUCCESS:
      return {
        ...state,
        list: action.payload?.data,
        status: statuslist[action.payload.status],
      }
    case GET_SPECIFICATION_LIST_ERROR:
      return {
        ...state,
        list: {},
        errorList: action.payload?.data,
        status: statuslist.error,
      }
    default:
      return state
  }
}

export default Specification
